var GalleryModal = (function () {


  function init() {
    var $galleries = $('.acr-mini-gallery, .acr-gallery');

    $galleries.each(function (i, o) {
      var gallery = InitSingleGallery();
      gallery.init(o);
    });
  }

  var InitSingleGallery = function () {
    var $gallery;

    var $galleryModal;

    var $pictureContainer;

    var $picture;

    var $body;

    var $spinner;

    var interval = [];

    var debounce;

    var imgContainerAspectRatio = 46 / 30;

    var videoContainerAspectRatio = 16 / 9;

    var player;

    var playerReady = false;

    var swipeStartX;

    var swipeEndX;

    var swipeThreshold = 20;

    var maxTries = 50;

    var tries = 0;

    var spinner = document.createElement('div');

    var pictureContainer = document.createElement('div');

    var picture = document.createElement('picture');

    var img = document.createElement('img');

    var sourceM = document.createElement('source');

    var sourceL = document.createElement('source');

    var sourceXL = document.createElement('source');

    var svgIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

    var useElem = document.createElementNS('http://www.w3.org/2000/svg', 'use');

    function init(g) {
      $gallery = $(g);

      $body = $('body');

      $galleryModal = $gallery.next('.acr-gallery-modal');

      // for gallery compatibility
      if ($galleryModal.length === 0) {
        $galleryModal = $gallery.parent().next('.acr-gallery-modal');
      }

      pictureContainer.setAttribute('class', 'picture-container visible');

      $pictureContainer = $galleryModal.find('picture-container');

      createPicture();

      attachClicks();

      attachKeyboardInput();

      attachResize();

      attachLoad();

      attachTouch();

      layout();
    }

    function attachClicks() {
      var $modalAnchors = $gallery.find('[data-acr-gallery-modal]');

      var $modalAnchorIcons = $gallery.find('.grid .acr-icon-direction-45');

      $modalAnchors.off('click', openHandler)
        .on('click', openHandler);

      $modalAnchorIcons.off('click', openHandler)
        .on('click', openHandler);

      $galleryModal.find('.acr-icon.gallery-modal-close')
        .off('click', closeHandler)
        .on('click', closeHandler);

      $galleryModal.find('.acr-icon.gallery-modal-close use')
        .off('click', closeHandler)
        .on('click', closeHandler);

      $galleryModal.find('.next-container')
        .off('click', next)
        .on('click', next);

      $galleryModal.find('.prev-container')
        .off('click', prev)
        .on('click', prev);
    }

    function attachKeyboardInput() {
      $(document).off('keyup', keyboardHandler)
        .on('keyup', keyboardHandler);
    }

    function attachResize() {
      $(window).off('resize', layout);

      $(window).resize(onResize);
    }

    function onResize() {
      clearTimeout(debounce);
      debounce = setTimeout(layout, 250);
    }

    function attachLoad() {
      $galleryModal.find('img').one('load', function () {
        layout();
      }).each(function () {
        if (this.complete) {
          $(this).load();
        }
      });
    }

    function attachTouch() {
      var $gallerySlider = $galleryModal.find('.gallery-slider');

      $gallerySlider.off('touchstart', touchStartHandler)
        .on('touchstart', touchStartHandler);

      $gallerySlider.off('touchmove', touchMoveHandler)
        .on('touchmove', touchMoveHandler);

      $gallerySlider.off('touchend', touchEndHandler)
        .on('touchend', touchEndHandler);
    }

    function touchStartHandler(e) {
      swipeStartX = e.originalEvent.touches[0].clientX;
    }

    function touchMoveHandler(e) {
      swipeEndX = e.originalEvent.touches[0].clientX;
    }

    function touchEndHandler() {
      var dX = swipeStartX - swipeEndX;

      if (!swipeStartX || !swipeEndX
        || Math.abs(dX) < swipeThreshold) {
        return;
      }

      if (dX > 0) {
        next();
      } else {
        prev();
      }

      swipeStartX = null;

      swipeEndX = null;
    }

    function openHandler(e) {
      e.preventDefault();

      var $anchor = $(this);

      if (typeof $anchor.data('acrGalleryModal') === 'undefined') {
        $anchor = $anchor.siblings('[data-acr-gallery-modal]');
      }

      populateModal($anchor);

      ImageChanger.init();

      $('body').bind('touchmove', function (e) {
        e.preventDefault();
      });
    }

    function populateModal($anchor) {
      var $parent = $anchor.parents('.grid');

      var $siblings = $parent.find('[data-acr-gallery-modal]:visible');

      tries = 0;

      var $image = $galleryModal.find('img');

      $image.removeClass('visible');

      $spinner.addClass('visible');

      $parent.addClass('current-gallery');

      $parent.data('currentIndex', $siblings.index($anchor));

      if ($anchor.data('type') === 'image') {

        if ($anchor.data('retina') === 'off') {
          sourceXL.setAttribute('srcset', $anchor.attr('data-img-xlarge-1x'));
          sourceL.setAttribute('srcset', $anchor.attr('data-img-large-1x'));
          sourceM.setAttribute('srcset', $anchor.attr('data-img-medium-1x'));
          img.setAttribute('srcset', $anchor.attr('data-img-xsmall-1x'));
          img.setAttribute('alt', $anchor.attr('data-alt'));
        } else {
          sourceXL.setAttribute('srcset', $anchor.attr('data-img-xlarge-1x')
          + ', ' + $anchor.attr('data-img-xlarge-2x') + ' 2x');
          sourceL.setAttribute('srcset', $anchor.attr('data-img-large-1x')
          + ', ' + $anchor.attr('data-img-large-2x') + ' 2x');
          sourceM.setAttribute('srcset', $anchor.attr('data-img-medium-1x')
          + ', ' + $anchor.attr('data-img-medium-2x') + ' 2x');
          img.setAttribute('srcset',
            $anchor.attr('data-img-xsmall-1x')
            + ', ' + $anchor.attr('data-img-xsmall-2x') + ' 2x');
          img.setAttribute('alt', $anchor.attr('data-alt'));
        }


        $(img).load(function () {
          $image.addClass('visible');
          $spinner.removeClass('visible');
        });

        $picture.addClass('visible');

        $galleryModal.find('iframe').removeClass('visible');

        Utility.reevaluatePictureFill();
      } else {
        // dirty hack
        $('.acr-gallery-modal [id=gallery-modal-youtube]').remove();
        $('<div id="gallery-modal-youtube"></div>')
          .insertAfter($galleryModal.find('picture'));
        if ($anchor.data('videoTracking')) {
          $galleryModal.find('.picture-container').attr('data-video-tracking', $anchor.data('videoTracking'));
        }


        playerReady = false;

        window.setVideoPercentages();

        player = new YT.Player('gallery-modal-youtube', {

          videoId: $anchor.data('videoUrl'),
          events: {
            onReady: onPlayerReady,
            onStateChange: Acr.YouTubeManager.onPlayerStateChange,
          },
          playerVars: {
            showinfo: 0,
            theme: 'light',
            color: 'white',
            rel: 0,
          },
        });

        $picture.removeClass('visible');

        $galleryModal.find('iframe').addClass('visible');
      }

      $galleryModal.find('.content-name').text($anchor.data('name'));

      $galleryModal.find('.header-name').text($anchor.data('name'));

      $galleryModal.find('.description').html($anchor.data('description').replace(/"/g, '&#34;').replace(/'s/g, '&#39;s'));

      $galleryModal.find('.cta-text').text($anchor.data('ctaText'));

      $galleryModal.find('.cta-anchor').attr('href', $anchor.data('ctaUrl'));

      if ($anchor.data('ctaUrl') && $anchor.data('ctaText')) {
        $galleryModal.find('.cta-anchor').addClass('visible');
      } else {
        $galleryModal.find('.cta-anchor').removeClass('visible');
      }

      $galleryModal.addClass('visible');

      layout();

      createSvg($anchor.data('social-icon'));

      $body.addClass('modal-open');

      Acr.Disclaimer.init();
    }

    function closeHandler() {

      $galleryModal.removeClass('visible');

      clearInterval(window.percentageInterval);

      $body.removeClass('modal-open');

      if (player && playerReady && player.getPlayerState() === 1) {
        player.stopVideo();
      }

      $('body').unbind('touchmove');

      $(window).trigger('ar.closemodal');
    }

    function keyboardHandler(e) {
      var galleryIsVisible = $galleryModal.hasClass('visible');

      if (e.which === 27) { // esc key
        closeHandler();
      } else if (e.which === 37 && galleryIsVisible) { // left arrow
        prev();
      } else if (e.which === 39 && galleryIsVisible) { // right arrow
        next();
      }
    }

    function layout() {
      if (!$galleryModal.hasClass('visible')) {
        return;
      }

      var $image = $galleryModal.find('img');

      var windowHeight = $(window).height();

      var windowWidth = $(window).width();

      var imgHeight = $image.height();

      var $iframe = $galleryModal.find('iframe');

      if ((!$image[0].currentSrc)
        && $picture.hasClass('visible') && tries < maxTries) {
        interval.push(setInterval(layout, 250));

        tries++;

        return;
      }
      for (var i = 0; i < interval.length; i++) {
        clearInterval(interval[i]);
      }
      interval = [];


      var imageAspectRatio = $image[0].naturalWidth / $image[0].naturalHeight;

      if (windowWidth < Constants.breakpoints.sm) {
        var headerHeight = $galleryModal.find('.header').height();

        var sliderHeight = $galleryModal.find('.gallery-slider').height();

        if ($picture.hasClass('visible')) {
          $pictureContainer.innerHeight(windowWidth / imgContainerAspectRatio);

          if (imgContainerAspectRatio > imageAspectRatio) {
            $picture.height(windowWidth / imgContainerAspectRatio);

            $picture.width(windowWidth / imgContainerAspectRatio
                  * imageAspectRatio);
          } else {
            $picture.width(windowWidth);

            $picture.height(windowWidth / imageAspectRatio);
          }

        } else {
          $iframe.innerHeight(windowWidth / imgContainerAspectRatio);

          $iframe.width(windowWidth);
        }

        $galleryModal.find('.content').innerHeight(
          windowHeight - headerHeight - sliderHeight,
        );
      } else {
        // if the modal height is bigger than 625 the content should be 40%
        // otherwise it should be 150px
        var contentHeight = (windowHeight > 625) ? 150 : windowHeight * 0.4;

        var containerAspectRatio = windowWidth / (windowHeight - contentHeight);

        if ($picture.hasClass('visible')) {
          $pictureContainer.innerHeight(windowHeight - contentHeight);

          if (containerAspectRatio > imageAspectRatio) {
            $picture.height(windowHeight - contentHeight);

            $picture.width((windowHeight - contentHeight) * imageAspectRatio);
          } else {
            $picture.width(windowWidth);

            $picture.height(windowWidth / imageAspectRatio);
          }

        } else if (containerAspectRatio > videoContainerAspectRatio) {
          $iframe.innerHeight(windowHeight - contentHeight);

          $iframe.width((windowHeight - contentHeight)
              * videoContainerAspectRatio);
        } else {
          $iframe.width(windowWidth);

          $iframe.height(windowHeight - contentHeight);
        }

        $galleryModal.find('.content').innerHeight(contentHeight);

        $body.addClass('modal-open');

      }
    }

    function prev() {
      var $parent = $gallery.find('.grid.current-gallery');

      var thumbs = $parent.find('[data-acr-gallery-modal]:visible');

      var currentIndex = $parent.data('currentIndex');

      currentIndex = (currentIndex === 0)
        ? thumbs.length - 1 : currentIndex - 1;

      populateModal($(thumbs[currentIndex]));

      if (player && playerReady && player.getPlayerState() === 1) {
        player.stopVideo();
      }
    }

    function next() {
      var $parent = $gallery.find('.grid.current-gallery');

      var thumbs = $parent.find('[data-acr-gallery-modal]:visible');

      var currentIndex = $parent.data('currentIndex');

      currentIndex = (currentIndex + 1) % thumbs.length;

      populateModal($(thumbs[currentIndex]));

      if (player && playerReady && player.getPlayerState() === 1) {
        player.stopVideo();
      }
    }

    function onPlayerReady() {
      var $image = $galleryModal.find('img');

      playerReady = true;

      $image.addClass('visible');
      $spinner.removeClass('visible');

      layout();
    }

    function createPicture() {
      sourceXL.setAttribute('media', '(min-width: 1400px)');

      sourceL.setAttribute('media', '(min-width: 1024px)');

      sourceM.setAttribute('media', '(min-width: 550px)');

      spinner.setAttribute('class', 'animated-spinner visible');

      picture.appendChild(sourceXL);

      picture.appendChild(sourceL);

      picture.appendChild(sourceM);

      picture.appendChild(img);

      $picture = $(picture);

      $spinner = $(spinner);

      $pictureContainer = $(pictureContainer);

      pictureContainer.appendChild(spinner);

      pictureContainer.appendChild(picture);

      $(pictureContainer).insertBefore($galleryModal.find('.next-container'));
    }

    function createSvg($svgName) {
      svgIcon.setAttribute('class', 'acr-icon-social-modal');

      useElem.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#' + $svgName);

      svgIcon.appendChild(useElem);

      picture.appendChild(svgIcon);
    }

    return {
      init: init,
    };
  };

  return {
    init: init,
  };
}());
